import { useQuery } from "@tanstack/react-query";
import { ThemeWrapper } from "@verity/components";
import { useContext, useEffect } from "react";
import apiClient from "../../../helpers/api-client";
import { PortalControllerContext } from "../../context";
import homeStyles from "../../portal.module.css";
import { error400, getLogoutUrl, useIsInstructor } from "../../shared";
import InterviewInstructorDashboard from "./InstructorHomePage/Dashboard/InterviewInstructorDashboard";
import InterviewDashboardSkeleton from "./InstructorHomePage/Dashboard/InterviewInstructorDashboardSkeleton";
import InterviewInstructorWelcomePage from "./InstructorHomePage/WelcomePage/InterviewInstructorWelcomePage";

export default function InterviewsHomePage() {
	const { portalContext } = useContext(PortalControllerContext);
	const { instituteId, homeOrigin, courseId } = portalContext;
	const isInstructor = useIsInstructor();

	const { data: hasShownWelcome, isLoading } = useQuery<boolean>({
		queryKey: ["welcome"],
		queryFn: () => apiClient.user.getHasShownCandidateWelcome(),
	});

	useEffect(() => {
		if (!courseId || !isInstructor) return;
		void apiClient.user.assignInterviewerRole({ courseId: courseId });
	}, [courseId, isInstructor]);

	useEffect(() => {
		async function logout() {
			await apiClient.setAccountId(undefined);
			await apiClient.setRefreshToken(undefined);
			await apiClient.setAccessToken(undefined);
			await apiClient.authentication.logout();
			window.location.href = getLogoutUrl(homeOrigin);
		}

		if (!isInstructor) void logout();
	}, [isInstructor, homeOrigin]);

	if (instituteId == null) return <iframe className={homeStyles.iframePage} src={error400}></iframe>;

	if (isLoading) return <InterviewDashboardSkeleton />;

	if (!isInstructor) return null;

	if (!hasShownWelcome)
		return (
			<ThemeWrapper scoped={false}>
				<InterviewInstructorWelcomePage />
			</ThemeWrapper>
		);

	return (
		<ThemeWrapper scoped={false}>
			<InterviewInstructorDashboard />
		</ThemeWrapper>
	);
}
